import { handleService } from "./common";

export default {
  // 获得设备类型
  GetVersionType() {
    let url = "/api/Version/GetType";
    // debugger
    return handleService(url);
  },

  // 获得版本列表
  GetVersionTable(data) {
    let url = "/api/Version/GetListByPage";
    // debugger
    return handleService(url, data);
  },

  // 删除版本
  DelSelected(data) {
    let url = "/api/Version/Delete";
    // debugger
    return handleService(url, data, "DELETE");
  },

  // 获得当前版本的详请
  GetVersionDetail(data) {
    let url = "/api/Version/Get";
    // debugger
    return handleService(url, data);
  },

  // 新增版本
  AddNewVersion(data) {
    let url = "/api/Version/Add";
    return handleService(url, data, "POST");
  },

  // 编辑版本
  EditNewVersion(data) {
    let url = "/api/Version/Update";
    return handleService(url, data, "PUT");
  },

  //设备型号
  GetEquType(data) {
    let url = "/api/Version/GetEquType";
    return handleService(url, data);
  },
  //WisdomPark/v2/Version/UpdateVersion  更新版本状态
  // UpdateVersion(data) {
  //   let url = "/api/Version/UpdateVersion";
  //   return handleService(url, data, "POST");
  // }
};
